var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorksetConnectedNoReservations24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WorksetConnectedNoReservations_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,16a5,5,0,1,1-5-5A5,5,0,0,1,17,16Zm-1.8-1.69-.66-.64a.25.25,0,0,0-.36,0l-2.9,2.9a.25.25,0,0,1-.37,0L9.86,15.52a.27.27,0,0,0-.37,0l-.65.65a.27.27,0,0,0,0,.37l1.65,1.66a.72.72,0,0,0,.44.18h.31a.7.7,0,0,0,.44-.18l3.52-3.52A.27.27,0,0,0,15.2,14.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,7a7.49,7.49,0,0,0-14-2,6,6,0,0,0-.28,11.88A7,7,0,0,1,5,16a6.74,6.74,0,0,1,.1-1.11A4,4,0,0,1,6,7h.71A5.5,5.5,0,0,1,17.5,8.5V9H19a3,3,0,0,1,0,6h-.08a6.29,6.29,0,0,1,0,2H19a5,5,0,0,0,.35-10Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksetConnectedNoReservations24);
export default __webpack_public_path__ + "static/media/WorksetConnectedNoReservations_24.b63478c6b5228c26c0d34ab244283d62.svg";
export { ForwardRef as ReactComponent };